<template>
    <v-container 
        fluid 
        px-0 
        pt-5>
        <v-row>
            <v-col 
                md="6" 
                offset-md="3">
                <v-form 
                    ref="form" 
                    v-model="valid" 
                    :lazy-validation="lazy">
                    <v-row>
                        <v-col style="padding-bottom:0px;">
                            <v-file-input
                                v-model="file"
                                :key="'input_file_' + tipoDocumento.idTipoDocDigPk"
                                :label="labelFile"
                                :disabled="isLoaded && hasFile"
                                :loading="loading"
                                :rules="[v => !!v || 'El archivo es requerido']"
                                solo
                                show-size
                                required
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col style="text-align:center">
                            <v-btn
                                v-if="isLoaded && !hasFile"
                                :loading="loading"
                                dark
                                small
                                color="success"
                                style="margin-top: -6px;"
                                class="mr-1 mt-2"
                                @click="guardarDocumento"
                            >
                                <v-icon>mdi-upload</v-icon>
                                Subir archivo
                            </v-btn>
                            <v-btn
                                v-if="isLoaded && !hasFile && banderaExistia"
                                :loading="loading"
                                dark
                                small
                                color="grey"
                                style="margin-top: -6px;"
                                class="mr-1 mt-2"
                                @click="getDataDocumentoUsuarioByIdTipoDocumento_()"
                            >
                                <v-icon>mdi-close</v-icon>
                                Cancelar
                            </v-btn>

                            <v-btn
                                v-if="isLoaded && hasFile"
                                :loading="loading"
                                dark
                                small
                                color="primary"
                                style="margin-top: -6px;"
                                class="mr-1 mt-2"
                                @click="getDataDocumentoFile_()"
                            >
                                <v-icon>mdi-download</v-icon>
                                Descargar
                            </v-btn>
                            <v-btn
                                v-if="isLoaded && hasFile"
                                :loading="loading"
                                dark
                                small
                                color="blue-grey"
                                style="margin-top: -6px;"
                                class="mr-1 mt-2"
                                @click="updateDocumento()"
                            >
                                <v-icon>mdi-refresh</v-icon>
                                Actualizar
                            </v-btn>
                            <!-- <v-btn
                v-if="isLoaded && hasFile"
                dark
                small
                color="error"
                style="margin-top: -6px;"
                class="mr-1"
                :loading="loading"
                @click="dialogEliminar = true"
              >
                <v-icon>mdi-delete</v-icon>
                Eliminar
              </v-btn> -->
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="snackbarGuardarDoc"
            :key="'snackbar_file_' + tipoDocumento.idTipoDocDigPk"
            :bottom="true"
            :color="colorGuardarDoc"
            :multi-line="true"
            :timeout="timeoutGuardarDoc"
        >
            {{ textGuardarDoc }}
            <v-btn 
                dark 
                text 
                @click="snackbarGuardarDoc = false">
                Cerrar
            </v-btn>
        </v-snackbar>
        <v-dialog 
            v-model="dialogActualizar" 
            persistent 
            max-width="400">
            <v-card>
                <v-card-title class="headline">
                    ¿Está seguro?
                </v-card-title>
                <v-card-text
                >Al actualizar el documento quedará pendiente la validación de los
                servicios que lo tengan como requisito. ¿Desea continuar?</v-card-text
                >
                <v-card-actions>
                    <div class="flex-grow-1" />
                    <v-btn
                        :loading="loading"
                        color="grey darken-1"
                        text
                        @click="dialogActualizar = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        :loading="loading"
                        color="primary"
                        text
                        @click="confirmarActualizar()"
                    >
                        Si, actualizar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import {
  getDataDocumentoUsuarioByIdTipoDocumento,
  postDataDocumento,
  getDataDocumentoFile
  // deleteDataDiagnosticoParticular
} from "@/api";

export default {
  name: "FormularioDocumento",
  components: {},
  props: {
    tipoDocumento: {
      type: Object,
      required: true
    },
    idRequisito: {
      type: Number,
      default: 0
    },
    validarRequisito: {
      type: Function,
      default: () => 1
    }
  },
  data () {
    return {
      file: null,
      loading: false,
      isLoaded: false,
      hasFile: false,
      labelFile: "",
      valid: false,
      lazy: false,
      snackbarGuardarDoc: false,
      colorGuardarDoc: "",
      textGuardarDoc: "",
      timeoutGuardarDoc: 0,
      uuid: "",
      nombreOriginal: "",
      idArchivoPk: 0,
      dialogActualizar: false,
      banderaExistia: false
    };
  },
  computed: {},
  mounted () {
    this.getDataDocumentoUsuarioByIdTipoDocumento_();
  },
  methods: {
    async getDataDocumentoUsuarioByIdTipoDocumento_ () {
      var self = this;
      self.loading = true;

      try {
        let response = await getDataDocumentoUsuarioByIdTipoDocumento(
          self.tipoDocumento.idTipoDocDigPk
        );

        self.resetValidation();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message !== "No hay archivo") {
              self.labelFile = response.data.data.nombreArchivo;
              self.nombreOriginal = response.data.data.nombreArchivo;
              self.idArchivoPk = response.data.data.idArchivoPk;
              self.uuid = response.data.data.id;
              self.hasFile = true;
              if (self.idRequisito !== 0)
                self.validarRequisito(self.idRequisito, true);
            } else {
              self.labelFile = self.tipoDocumento.descripcion;
              self.nombreOriginal = "";
              self.idArchivoPk = 0;
              self.uuid = "";
              self.hasFile = false;
              if (self.idRequisito !== 0)
                self.validarRequisito(self.idRequisito, false);
            }

            self.file = null;

            self.loading = false;
            self.isLoaded = true;
          } else {
            self.colorGuardarDoc = "error";
            self.textGuardarDoc = response.data.message;
            self.timeoutGuardarDoc = 7000;
            self.snackbarGuardarDoc = true;

            self.nombreOriginal = "";
            self.uuid = "";
            self.idArchivoPk = 0;

            self.hasFile = false;
            self.labelFile = self.tipoDocumento.descripcion;
            self.loading = false;
            self.isLoaded = true;

            if (self.idRequisito !== 0)
              self.validarRequisito(self.idRequisito, false);
          }
        } else {
          self.colorGuardarDoc = "error";
          self.textGuardarDoc = "Error. Inténtelo de nuevo más tarde.";
          self.timeoutGuardarDoc = 7000;
          self.snackbarGuardarDoc = true;

          self.nombreOriginal = "";
          self.uuid = "";
          self.idArchivoPk = 0;

          self.hasFile = false;
          self.labelFile = self.tipoDocumento.descripcion;
          self.loading = false;
          self.isLoaded = true;

          if (self.idRequisito !== 0)
            self.validarRequisito(self.idRequisito, false);
        }
      } catch (e) {
        self.colorGuardarDoc = "error";
        self.textGuardarDoc =
          e.message === "Network Error"
            ? "Error de red. Inténtelo de nuevo más tarde."
            : e.message;
        self.timeoutGuardarDoc = 7000;
        self.snackbarGuardarDoc = true;

        self.nombreOriginal = "";
        self.uuid = "";
        self.idArchivoPk = 0;

        self.hasFile = false;
        self.labelFile = self.tipoDocumento.descripcion;
        self.loading = false;
        self.isLoaded = true;

        if (self.idRequisito !== 0)
          self.validarRequisito(self.idRequisito, false);
      }
    },
    async guardarDocumento () {
      var self = this;

      if (this.$refs.form.validate()) {
        self.loading = true;

        try {
          var obj = {};
          obj.idArchivoPk = 0;
          obj.idTipoDocumento = self.tipoDocumento.idTipoDocDigPk;
          obj.nombreOriginal = "";

          let response = await postDataDocumento(obj, self.file);

          if (response.status === 200) {
            if (response.data.flag === true) {
              self.colorGuardarDoc = "success";
              self.textGuardarDoc =
                self.tipoDocumento.descripcion + " guardado con éxito.";
              self.snackbarGuardarDoc = true;
              self.timeoutGuardarDoc = 7000;

              self.loading = false;

              self.getDataDocumentoUsuarioByIdTipoDocumento_();
            } else {
              self.colorGuardarDoc = "error";
              self.textGuardarDoc = response.data.message;
              self.timeoutGuardarDoc = 7000;
              self.snackbarGuardarDoc = true;

              self.hasFile = false;
              self.labelFile = self.tipoDocumento.descripcion;
              self.loading = false;
            }
          } else {
            self.colorGuardarDoc = "error";
            self.textGuardarDoc = "Error. Inténtelo de nuevo más tarde.";
            self.timeoutGuardarDoc = 7000;
            self.snackbarGuardarDoc = true;

            self.hasFile = false;
            self.labelFile = self.tipoDocumento.descripcion;

            self.loading = false;
          }
        } catch (e) {
          self.colorGuardarDoc = "error";
          self.textGuardarDoc =
            e.message === "Network Error"
              ? "Error de red. Inténtelo de nuevo más tarde."
              : e.message;
          self.timeoutGuardarDoc = 7000;
          self.snackbarGuardarDoc = true;

          self.hasFile = false;
          self.labelFile = self.tipoDocumento.descripcion;
          self.loading = false;
        }
      }
    },
    async getDataDocumentoFile_ () {
      var self = this;
      self.loading = true;

      try {
        let response = await getDataDocumentoFile(self.idArchivoPk, self.uuid);

        if (response.status === 200) {
          var fileURL = window.URL.createObjectURL(new atob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", self.nombreOriginal);
          document.body.appendChild(fileLink);

          fileLink.click();

          self.loading = false;
        } else {
          self.colorGuardarDoc = "error";
          self.textGuardarDoc = "Error. Inténtelo de nuevo más tarde.";
          self.timeoutGuardarDoc = 7000;
          self.snackbarGuardarDoc = true;

          self.loading = false;
        }
      } catch (e) {
        self.colorGuardarDoc = "error";
        self.textGuardarDoc =
          e.message === "Network Error"
            ? "Error de red. Inténtelo de nuevo más tarde."
            : e.message;
        self.timeoutGuardarDoc = 7000;
        self.snackbarGuardarDoc = true;

        self.loading = false;
      }
    },
    updateDocumento () {
      this.dialogActualizar = true;
      // this.hasFile = false;
      // this.labelFile = this.tipoDocumento.descripcion;
    },
    confirmarActualizar () {
      this.hasFile = false;
      this.labelFile = this.tipoDocumento.descripcion;
      this.dialogActualizar = false;
      this.banderaExistia = true;
      if (this.idRequisito !== 0)
        this.validarRequisito(this.idRequisito, false);
    },
    reset () {
      this.$refs.form.reset();
    },
    resetValidation () {
      this.$refs.form.resetValidation();
    }
  }
};
</script>
